/**
 * Hauteur fixe du bandeau « démonstration » (px).
 * Aligné avec : `DemoBanner`, `Header` (`top`), suggestion d’agence.
 * Le `padding-top` du `<main>` vient de `--epp-shell-top` (mesuré dans `Header` :
 * bandeau démo + hauteur réelle du header).
 */
/** Bandeau démo premium (une ligne + padding) — aligné Header / --epp-shell-top */
export const DEMO_BANNER_HEIGHT_PX = 56;

/**
 * Largeur max du shell (header, main, sections, footer) — une seule source.
 */
export const SITE_SHELL_MAX =
  "max-w-[min(100%,1580px)] 2xl:max-w-[min(100%,1760px)]";

/**
 * Contenu centré + padding horizontal — toutes les pages vitrine.
 * Alias historique : CONTAINER_CLASS = même chose que WIDE_CONTENT_WRAP.
 */
export const WIDE_CONTENT_WRAP =
  `w-full ${SITE_SHELL_MAX} mx-auto px-4 md:px-6 xl:px-8`;

export const CONTAINER_CLASS = WIDE_CONTENT_WRAP;
